// extracted by mini-css-extract-plugin
export default {"transcriptContainer":"VideoTranscript_transcriptContainer__GEgyH"};